import { useStacklineTheme } from '@stackline/ui';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import _merge from 'lodash/merge';
import Highcharts from 'src/components/Highcharts';

export interface GaugeChartProps {
  chartOptions: Highcharts.Options;
}

/**
 * A generic gauge chart component that can be used to display a single metric.
 * Used as the center of the spider chart.
 */
export const GaugeChart = ({ chartOptions = {} }: GaugeChartProps) => {
  const theme = useStacklineTheme();
  const defaultGaugeChartProps = {
    chart: {
      type: 'solidgauge',
      height: 235,
      width: 235,
      backgroundColor: 'transparent',
      spacing: [0, 0, 0, 0],
      marginLeft: 0,
      marginRight: 0,
      marginBottom: 0,
      marginTop: 0
    },
    title: {
      verticalAlign: 'middle',
      floating: true,
      useHTML: true,
      text: ``,
      style: {
        fontWeight: 'bold', // Adjust the size as needed
        fontFamily: 'Roboto',
        color: theme.colors.primary
      }
    },
    // Gauge background
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [
        {
          // Active Track (Filled)
          outerRadius: '0',
          innerRadius: '85%',
          backgroundColor: `#FFFFFF`,
          borderWidth: 0
        },
        {
          // Non-active Track (Non-Filled)
          outerRadius: '84%',
          innerRadius: '100%',
          backgroundColor: `#F6F7F8`,
          borderWidth: 0
        }
      ]
    },
    yAxis: {
      //   max: convertDataToBarHeights.size,
      lineWidth: 0,
      tickPositions: []
    },

    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: false
        },
        linecap: 'round',
        stickyTracking: false,
        rounded: true
      }
    },
    tooltip: {
      enabled: false
    },
    exporting: {
      enabled: false // Disables the export context button
    },
    credits: { enabled: false }
  };

  const options = _merge(defaultGaugeChartProps, chartOptions);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
